var Handlebars = require("/home/travis/build/OpenBudget/open-budget-api/webapp/open-budget/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"initial-loader\">\n  <div class=\"loading-indicator\">"
    + ((stack1 = container.invokePartial(require("/home/travis/build/OpenBudget/open-budget-api/webapp/open-budget/app/scripts/Hasadna/oBudget/Pages/Exemptions/sk-fading-circle.hbs"),depth0,{"name":"./sk-fading-circle","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</i></div>\n</div>\n";
},"usePartial":true,"useData":true});


//////////////////
// WEBPACK FOOTER
// ./app/scripts/Hasadna/oBudget/Pages/Exemptions/initial-loader.hbs
// module id = 109
// module chunks = 0